import React from 'react'
import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import CustomModal from 'components/commons/CustomModal'
import ErrorIcon from '@material-ui/icons/Error'
import questionnaireStyles from '../CreateQuestionnaire/styles'
import { useHistory } from 'react-router-dom'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Alert from '@material-ui/lab/Alert'
const useStyles = makeStyles(theme => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3)
   },
   alert: {
      marginBottom: '10px'
   },
   alertConatiner: {
      maxHeight: '400px',
      overflowY: 'scroll',
      paddingRight: '10px'
   }
}))

function ConfirmationModal({
   showComfirmationModal,
   setShowComfirmationModal,
   errors
}) {
   const classesModal = useStyles()
   const history = useHistory()
   const classes = questionnaireStyles()
   return (
      <Modal
         open={showComfirmationModal}
         className={classesModal.modal}
         aria-labelledby="spring-modal-title"
         aria-describedby="spring-modal-description"
         onClose={() => setShowComfirmationModal(false)}
         BackdropComponent={Backdrop}
         closeAfterTransition
         BackdropProps={{
            timeout: 500
         }}
      >
         <div className={classesModal.paper}>
            <Grid className={classes.confirmModalContainer}>
               <Typography
                  style={{
                     marginBottom: 16,
                     width: '60%',
                     alignSelf: 'center',
                     textAlign: 'center',
                     fontWeight: 800
                  }}
               >
                  Señor usuario, el cuestionario no cumple con los siguientes
                  requisitos:
               </Typography>
               <div className={classesModal.alertConatiner}>
                  {errors?.map((error, index) => (
                     <Alert
                        key={index}
                        className={classesModal.alert}
                        severity="error"
                     >
                        {error}
                     </Alert>
                  ))}
               </div>
               <div className={classes.modalButtonsContainer}>
                  <Button
                     style={{ margin: '0 10px 0 10px' }}
                     variant="contained"
                     disableElevation
                     color="primary"
                     onClick={() => setShowComfirmationModal(false)}
                  >
                     ENTENDIDO
                  </Button>
               </div>
            </Grid>
         </div>
      </Modal>
   )
}

export default ConfirmationModal
